let load = require('./helpers/browser/esm-js-loader-shards')(4);
module.exports = (load("2hamX")).then(() => parcelRequire('kz0bU'));